
import Event from "./EventSection";
import EventSlider from "./SliderSection";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "./DownloadApp";

const HomeMain = () => {
 
  return (
    <>
      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <EventSlider/>
          <Event/>
          <DownloadApp />
          <ScrollToTop scrollClassName="home react__up___scroll" />
        </div>
      </div>
    </>
  );
};

export default HomeMain;
